import { SitePage } from "../../pages/PageNames";
import { FeatureFlag } from "../featureFlags/FeatureFlagsModels";
import { ProductType } from "../purchasedProducts/Models";
import { UserAccessType } from "../user/Models";
import { ISiteVisibilityFilterArgs } from "./NavigationDrawer/NavigationDrawerModels";

const SingleSitePageAccessRules: Record<SitePage, (args: ISiteVisibilityFilterArgs) => boolean> = {
  [SitePage.Home]: ({ userAccessType }) => userAccessType >= UserAccessType.ViewDashboard,
  [SitePage.History]: ({ userAccessType }) => userAccessType >= UserAccessType.Viewer,
  [SitePage.Trackers]: ({ userAccessType }) => userAccessType >= UserAccessType.Viewer,
  [SitePage.ActivityLog]: ({ userAccessType, siteFeatureFlags }) =>
    userAccessType >= UserAccessType.Viewer &&
    siteFeatureFlags.includes(FeatureFlag.IsUserRecordFeatureEnabled),
  [SitePage.Agriculture]: ({ userAccessType, siteFeatureFlags }) =>
    userAccessType >= UserAccessType.Viewer && siteFeatureFlags.includes(FeatureFlag.IsAgriPageVisible),
  [SitePage.Alerts]: ({ userAccessType, siteFeatureFlags }) =>
    userAccessType >= UserAccessType.Viewer &&
    siteFeatureFlags.includes(FeatureFlag.IsIssuesFeatureEnabled),
  [SitePage.Faucets]: ({ userAccessType, siteFeatureFlags }) =>
    userAccessType >= UserAccessType.Viewer &&
    siteFeatureFlags.includes(FeatureFlag.IsSprinklersFeatureEnabled),
  [SitePage.Configuration]: ({ userAccessType }) => userAccessType >= UserAccessType.Engineer,
  [SitePage.Cameras]: ({ userAccessType, siteFeatureFlags }) =>
    userAccessType >= UserAccessType.Viewer && siteFeatureFlags.includes(FeatureFlag.CamerasPage),
  [SitePage.Deployments]: ({ userAccessType, siteFeatureFlags }) =>
    userAccessType >= UserAccessType.Commissioning &&
    siteFeatureFlags.includes(FeatureFlag.DeploymentPage),
  [SitePage.LossAnalysis]: ({ userAccessType, siteProducts }) =>
    userAccessType >= UserAccessType.Viewer && siteProducts.includes(ProductType.Soma),
  [SitePage.Trends]: ({ userAccessType }) => userAccessType >= UserAccessType.Viewer,
  [SitePage.Settings]: ({ userAccessType, siteFeatureFlags }) =>
    userAccessType >= UserAccessType.Operator &&
    siteFeatureFlags?.includes(FeatureFlag.IsSettingsPageEnabled),
  [SitePage.Reports]: ({ userAccessType, siteFeatureFlags }) =>
    userAccessType >= UserAccessType.Operator && siteFeatureFlags.includes(FeatureFlag.ReportsPage),
};

export const isTracsLiteRestricted = (siteProducts: ProductType[], userAccessType: UserAccessType) =>
  (siteProducts ?? []).includes(ProductType.TracsLite) && userAccessType < UserAccessType.Engineer;

export const isSitePageVisible = (pageName: SitePage, filterArgs: ISiteVisibilityFilterArgs) => {
  if (isTracsLiteRestricted(filterArgs.siteProducts, filterArgs.userAccessType)) {
    return false;
  }
  return SingleSitePageAccessRules[pageName](filterArgs);
};
